export default {
  "buttons": {
    "loginWithTwitch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login with Twitch"])},
    "loginWithTwitter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login with Twitter"])}
  }
}